// Service "lanes" the user can sign up for. Must mirror SERVICE_LANES in /app/backend/server.py.
// Each lane drives which dashboard sections + actions the user sees once logged in.
import { Building2, Briefcase, Coins, ShoppingBag, TrendingUp, Phone } from "lucide-react";

export const SERVICE_LANES = [
    {
        id: "landowner",
        label: "Landowner — I have land to sell or Joint Venture",
        short: "Landowner",
        desc: "Upload your land for outright sale, Joint Venture, or both. Each listing flagged separately.",
        icon: Building2,
        accent: "text-fiji-green",
    },
    {
        id: "agent",
        label: "Real Estate Agent",
        short: "Agent",
        desc: "Manage multiple landowner listings. Bulk upload, Joint Venture-eligible toggle per listing.",
        icon: Briefcase,
        accent: "text-ocean dark:text-turquoise",
    },
    {
        id: "investor",
        label: "Investor with capital",
        short: "Investor",
        desc: "Browse vetted Joint Ventures and land. Get first dibs on Premium deals matching your thesis.",
        icon: Coins,
        accent: "text-coral",
    },
    {
        id: "business_seller",
        label: "I have a business to sell",
        short: "Business seller",
        desc: "List your Fijian business — revenue, EBITDA, asking price. NDA-gated financials.",
        icon: ShoppingBag,
        accent: "text-coral",
    },
    {
        id: "business_buyer",
        label: "I'm looking to buy a business",
        short: "Business buyer",
        desc: "Browse Fiji businesses for sale. Save targets, request financials under NDA.",
        icon: TrendingUp,
        accent: "text-fiji-green",
    },
    {
        id: "consultation",
        label: "Just talk to the Bula team",
        short: "Consultation",
        desc: "Not sure where you fit? Book a call and we'll map your best move in Fiji real estate.",
        icon: Phone,
        accent: "text-ocean dark:text-turquoise",
    },
];

export const SERVICE_BY_ID = Object.fromEntries(SERVICE_LANES.map((s) => [s.id, s]));
